import type { ActionsObservable } from 'redux-observable';
import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mapTo';
import type { Action } from '../../../state/actions';
import { DELETE_PROJECT_SUCCESS } from '../../../state/ui/actions';
import type { AnalyticEvent } from '../types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<Action>): Observable<AnalyticEvent> =>
	action$
		.ofType(DELETE_PROJECT_SUCCESS)
		.mapTo({ event: 'delete-project-confirmation-modal.delete-button.click' });
